import { render, staticRenderFns } from "./BackofficeDash.vue?vue&type=template&id=ab6f036c"
import script from "./BackofficeDash.vue?vue&type=script&lang=js"
export * from "./BackofficeDash.vue?vue&type=script&lang=js"
import style0 from "./BackofficeDash.vue?vue&type=style&index=0&id=ab6f036c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports